let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("i5bWQ")).then(() => parcelRequire('kNLEl'));